/**
 * Five readable zones — prd2 § "Five Districts With Personality".
 * Used for building height / color variation (collision grid unchanged).
 */
export type DistrictId =
  | 'docks'
  | 'downtown'
  | 'highway'
  | 'suburbs'
  | 'industrial';

export function districtFromCell(cx: number, cz: number, half: number): DistrictId {
  const nx = cx / half;
  const nz = cz / half;
  if (nx < -0.18 && nz > 0.06) return 'docks';
  if (nx > 0.12 && nz > 0.04) return 'highway';
  if (Math.abs(nx) < 0.36 && nz > -0.12) return 'downtown';
  if (nx < 0.06 && nz < -0.08) return 'suburbs';
  if (nx > -0.02 && nz < -0.06) return 'industrial';
  return 'downtown';
}

export type DistrictStyle = {
  hMin: number;
  hMax: number;
  /** Multiplier for warm/cool facade tint (0–1). */
  cool: number;
  /** Extra emissive for neon downtown. */
  emissive: number;
};

export function districtStyle(d: DistrictId): DistrictStyle {
  switch (d) {
    case 'docks':
      return { hMin: 10, hMax: 26, cool: 0.72, emissive: 0.02 };
    case 'downtown':
      return { hMin: 32, hMax: 78, cool: 0.55, emissive: 0.09 };
    case 'highway':
      return { hMin: 12, hMax: 34, cool: 0.65, emissive: 0.03 };
    case 'suburbs':
      return { hMin: 8, hMax: 22, cool: 0.82, emissive: 0.02 };
    case 'industrial':
      return { hMin: 14, hMax: 44, cool: 0.62, emissive: 0.025 };
    default:
      return { hMin: 16, hMax: 40, cool: 0.7, emissive: 0.04 };
  }
}
